<template>
  <div id="vipOpenButton">
    <div  v-if="userInfo.viptype == 1 ">
      <div class="vip-open vip-left">
        <span class="app-msg-title">年度VIP</span>
        <button @click="toPay" >升级</button>
      </div>

      <div class="vip-open vip-right">
        <span class="app-msg-title">永久VIP</span>
        <button @click="toPay" >立即升级</button>
      </div>
    </div>

    <div  v-if="userInfo.viptype == 2 "> 
      <div class="vip-center">
        <span class="app-msg-title">永久VIP，让你永无后顾之忧</span>
        <button @click="toPay" >立即升级</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "vipOpenButton",
  data() {
    return {
      msg: "vipOpenButton"
    };
  },
  methods:{
     toPay: function() {
      this.$router.push("/pay");
    },
  },
  props: {
    userInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
<style  scoped>
#vipOpenButton {
  height: 170px;
  width: 600px;
  text-align: center;
  margin: 48px auto 48px auto;
}

.vip-open {
  height: 100%;
  width: 272px;
  top: 0px;
}

.vip-left {
  left: 0px;
  float: left;
}
.vip-right {
  right: 0px;
  float: right;
}

.vip-open span {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(244, 191, 157, 1);
  line-height: 76px;
}

.vip-open button {
  width: 272px;
  height: 92px;
  background: linear-gradient(
    90deg,
    rgba(238, 176, 142, 1) 0%,
    rgba(249, 220, 193, 1) 100%
  );
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  border: none;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 40px;
}

.vip-center {
  width: 100%;
  height: 100%;
}
.vip-center span {
  width: 352px;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #F5BFAB;
  line-height: 76px;
}
.vip-center button {
  width: 272px;
  height: 92px;
  background: linear-gradient(
    90deg,
    rgba(238, 176, 142, 1) 0%,
    rgba(249, 220, 193, 1) 100%
  );
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  border: none;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/vipOpenButton.vue